module.exports = __webpack_public_path__ + "static/media/gentec.5e88d186.png";